document.addEventListener('DOMContentLoaded', function() {
 const looxRatingAnchor = document.querySelector('a[href="#looxReviews"]');

 if(looxRatingAnchor) {
  const child = looxRatingAnchor.querySelector('.loox-widget')
  console.log(child.dataset.rates);
  if(!child.dataset.raters) {
    looxRatingAnchor.classList.add('loox-rating-anchor-no-reviews');
    looxRatingAnchor.innerHTML = looxRatingAnchor.innerHTML + '<span class="write-review-copy">(0)</span>';
    looxRatingAnchor.dataset.writeReviewCopy = 'Write a review';
  }
  setTimeout(() => {
    let reviewTitle = child.getAttribute('title');
    reviewTitle = reviewTitle.replace('vote', 'review');
    reviewTitle = reviewTitle.replace('1 reviews', '1 review');
    child.setAttribute('title', reviewTitle);

  }, 3000);
  looxRatingAnchor.addEventListener('click', function(event) {
    event.preventDefault();
    // smooth scroll to the loox reviews section
    // add 117px to the top of the section
    const offset = 117;
    const looxReviewsSection = document.querySelector('#looxReviews');
    
    if (looxReviewsSection) {
      const elementPosition = looxReviewsSection.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;
    
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  });
 }

 const addWriteReviewCopy = function() {
 }
});